<template>
  <div class="lepain-login-page">
    <el-row :gutter="60">
      <el-col :span="12">
        <div 
          :class="{
          'login-back-img': true,
          'login-talent': roleType == '1',
          'login-coach': roleType == '2'
          }">
          <img v-if="roleType === '1'" :src="registerImg" />
          <img style="height: 700px;object-fit: contain;" v-else :src="register2Img" />
        </div>
      </el-col>

      <el-col :span="12">
        <div class="back-icon" @click="$router.push('/')">
          <img :src="backIcon" /> Home
        </div>
        <div class="login-box">
          <div class="title typewriter">
            UNFOLDING THE FUTURE OF WORK
          </div>
          <!-- 登陆表单 -->
          <div class="form-content" v-if="loginFalg">
            <el-form :rules="loginRules" ref="loginForm" :model="loginForm" label-position="top">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="Email" prop="email">
                    <el-input v-model="loginForm.email"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="Password" prop="password">
                    <el-input type="password" show-password autocomplete="off" v-model="loginForm.password"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" style="text-align: center;">
                  <el-button :loading="signInLoading" type="primary" class="leapin-long-button" round  @click="handleSubmit()">Sign In</el-button>
                </el-col>
              </el-row>
            </el-form>
            <div
              :class="{
                'privacy-policy': true,
                'shake': showShakeFlag
              }">
              <el-checkbox v-model="privacyChecked"></el-checkbox>&nbsp;
              By continuing, you agree to the Unfolds AI 
              <span @click="intoTermService()">Terms of Service</span> and the 
              <span @click="intoPrivacy()">Privacy Policy</span>
            </div>
            <!-- 注册提示 -->
            <div class="regiter-tips">
              Don't you have an account? <span @click="registerFlag = true,loginFalg = false">Sign up</span>
            </div>
            <div class="regiter-tips">
              <span @click="forgotPwsFlag = true, registerFlag = false,loginFalg = false">Forgot password</span>
            </div>
          </div>
          <!-- 注册表单 -->
          <div class="form-content" v-if="registerFlag">
            <el-form ref="registerForm" :rules="registerRules" :model="registerForm" label-position="top">
              <!-- 邮箱、验证码 -->
              <div v-if="registerFirstStep">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Email" prop="email">
                      <el-input v-model="registerForm.email"></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :offset="1" :span="4">
                    <el-button :loading="butLoading" v-if="showSend" class="leapin-mt-38" type="primary" round @click.stop="getCode(1)">Send</el-button>
                    <div v-else class="leapin-mt-30 leapin-short-defalut-button">{{ timeCutDown }} s</div>
                    <el-button v-else round>{{ timeCutDown }} s</el-button>
                  </el-col> -->
                </el-row>
                <!-- 验证码 -->
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Password" prop="password">
                      <el-input type="password" show-password autocomplete="off" v-model="registerForm.password"></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :span="24">
                    <el-form-item label="Verification code" prop="verify_code">
                      <el-input v-model="registerForm.verify_code"></el-input>
                    </el-form-item>
                  </el-col> -->
                </el-row>
                <el-row :gutter="20" class="leapin-mt-20">
                  <div class="form-line">
                    <el-col :span="12" class="leapin-text-right">
                      <el-button round @click="registerFlag = false,loginFalg = true">Back</el-button>
                    </el-col>
                    <el-col :span="12">
                      <el-button :loading="butLoading" type="primary" round @click="handleRegister()">Sign Up</el-button>
                      <!-- <el-button type="primary" round @click="nextToMoreInfo()">Next</el-button> -->
                    </el-col>
                  </div>
                </el-row>
              </div>
              <!-- 其他信息 -->
              <!-- <div v-if="registerSecondStep">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="First name" prop="first_name">
                      <el-input v-model="registerForm.first_name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Last name" prop="last_name">
                      <el-input v-model="registerForm.last_name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :offset="6" :span="4">
                    <el-form-item label="Mobile" prop="mobile_country_code" :rules="[{ required: true, message: '', trigger: 'change' }]">
                      <el-tooltip
                        :content="registerForm.mobile_country_code+'('+nowPrefixName+')'"
                        placement="top-start">
                        <el-select filterable v-model="registerForm.mobile_country_code" @change="changePrefixCode" placeholder="Select">
                          <el-option
                              v-for="(item, key) of phonePrefixCode"
                              :value="item.code"
                              :key="key"
                              :title="item.code+'('+item.en+')'"
                              :label="item.code+'('+item.en+')'"
                            >
                            {{ item.code+'('+item.en+')' }}
                          </el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label=" " prop="mobile" :rules="[{ required: true, message: 'Please enter mobile', trigger: 'change' }]">
                      <el-input v-model="registerForm.mobile"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Password" prop="password">
                      <el-input type="password" autocomplete="off" v-model="registerForm.password"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Confirm Password" prop="confirm_password">
                      <el-input type="password" autocomplete="off" v-model="registerForm.confirm_password"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <div class="form-line">
                    <el-col :span="12" class="leapin-text-right">
                      <el-button round @click="registerSecondStep = false,registerFirstStep = true">Back</el-button>
                    </el-col>
                    <el-col :span="12">
                      <el-button :loading="butLoading" type="primary" round @click="handleRegister()">Sign Up</el-button>
                    </el-col>
                  </div>
                </el-row>
              </div> -->

            </el-form>
          </div>
          <!-- 忘记密码表单 -->
          <div class="form-content" v-show="forgotPwsFlag">
            <el-form ref="forgotPwsForm" :rules="forgotPwsRules" :model="forgotPwsForm" label-position="top">
              <!-- 邮箱 -->
              <el-row>
                <el-col :span="18">
                  <el-form-item label="Email" prop="email">
                    <el-input
                      autocomplete="off"
                      v-model="forgotPwsForm.email">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :offset="1" :span="4">
                  <el-button :loading="butLoading" v-if="showSend" class="leapin-mt-38" type="primary" round @click.stop="getCode(2)">Send</el-button>
                  <el-button class="leapin-mt-38" v-else round>{{ timeCutDown }} s</el-button>
                </el-col>
              </el-row>
              <!-- 验证码 -->
              <el-row>
                <el-col :span="24">
                  <el-form-item label="Verification code" prop="verify_code">
                    <el-input autocomplete="off" v-model="forgotPwsForm.verify_code"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 密码、确认密码 -->
              <el-row>
                  <el-col :span="24">
                    <el-form-item label="Password" prop="password">
                      <el-input type="password" show-password autocomplete="off" v-model="forgotPwsForm.password"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Confirm Password" prop="confirm_password">
                      <el-input type="password" show-password autocomplete="off" v-model="forgotPwsForm.confirm_password"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              <el-row :gutter="20">
                <div class="form-line">
                  <el-col :span="12" class="leapin-text-right">
                    <el-button round @click="forgotPwsFlag = false,registerFlag = false,loginFalg = true">Back</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button :loading="forgotLoading" type="primary" round  @click="handleForgetPassword()">Save</el-button>
                  </el-col>
                </div>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import newPhonePrefixCode from "@/constants/newPhonePrefixCode";
import { 
  signIn,
  userRegister,
  userVerifyCode,
  getUserInfo,
  userForgetPassword
} from "@/services/user.js";
export default {
  name: 'Login',
  data() {
    var checkEmail = (rule, value, callback) => {
      const regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (regEmail.test(value)) {
        callback();
      } else {
        callback(new Error('Please enter a valid email address'));
      }
    };
    var checkPassWord = (rule, value, callback) => {
      const regPassWord = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~`]).{8,}$/;
      if (regPassWord.test(value)) {
        callback();
      } else {
        callback(new Error('Password must contain at least 8 characters, including uppercase, lowercase, numbers and one special character'));
      }
    };
    return {
      showShakeFlag: false,
      privacyChecked: false,
      signInLoading: false,
      phonePrefixCode: newPhonePrefixCode,
      nowPrefixName: 'China',
      butLoading: false,
      roleType: '', // 1-求职者 2-教练 3-企业
      timeCutDown: 60,
      showSend: true,
      registerFirstStep: true,
      registerSecondStep: false,
      forgotPwsFlag: false,
      forgotLoading: false,
      loginFalg: true,
      registerFlag: false,
      registerImg: require('@/assets/images/users/login.png'),
      register2Img: require('@/assets/images/users/login2.png'),
      backIcon: require('@/assets/svgs/back.svg'),
      registerForm: {
        email: '',
        // first_name: '',
        // last_name: '',
        // mobile: '',
        // mobile_country_code: '86',
        // verify_code: '',
        role_key: "",  //# 角色key individual-求职者 coach-教练 enterprise-企业
        password: '',
        //confirm_password: ''
      },
      registerRules: {
        email: [
          { required: true, message: 'Please input email', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please input password', trigger: 'change' },
          { validator: checkPassWord, trigger: 'blur' }
        ],
        // first_name: [
        //   { required: true, message: 'Please input first name', trigger: 'blur' },
        // ],
        // last_name: [
        //   { required: true, message: 'Please input last name', trigger: 'blur' }
        // ],

        // verify_code: [
        //   { required: true, message: 'Please input verify code', trigger: 'change' }
        // ],
        // confirm_password: [
        //   { required: true, message: 'Please input confirm password', trigger: 'change' }
        // ],
        // mobile_country_code: [
        //   { required: true, message: 'Please select country code', trigger: 'change' }
        // ],
      },
      loginForm: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [
          { required: true, message: 'Please input email', trigger: 'change' },
        ],
        password: [
          { required: true, message: 'Please input password', trigger: 'change' }
        ]
      },
      forgotPwsForm: {
        email: '',
        verify_code: '',
        password: '',
        confirm_password: ''
      },
      forgotPwsRules: {
        email: [
          { required: true, message: 'Please input email', trigger: 'blur' }
        ],
        verify_code: [
          { required: true, message: 'Please input verification code', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please input password', trigger: 'blur' },
          { validator: checkPassWord, trigger: 'change' }
        ],
        confirm_password: [
          { required: true, message: 'Please input confirm password', trigger: 'blur' }
        ]
      }

    }
  },
  mounted () {
    this.roleType = this.$route.query.type
    //if (this.type === '2') {
      // this.loginFalg = false
      // this.registerFlag = true
    //}
  },
  methods: {
    changePrefixCode (val) {
      this.nowPrefixName = this.phonePrefixCode.filter(item => item.code === val)[0].en
    },
    // 获取验证码
    async getCode (num) {
      if (this.registerForm.email.length == 0 && this.forgotPwsForm.email.length == 0) {
        this.$message.warning('Please input email')
        return
      }
      let params = {
        key: num == 1 ? this.registerForm.email : this.forgotPwsForm.email, //邮箱或手机号
        type: 1, //类型  # 验证码类型: 0-手机 1-邮箱
        usage: num //用途  # 验证码用途: 0-登录 1-注册 2-找回密码
      }
      this.butLoading = true
      let res = await userVerifyCode(params)
      this.butLoading = false
      if (res.code !== 0) {
        this.$message.error(res.message)
        return
      }
      this.showSend = false
      this.timeCutDown = 60
      let timer = setInterval(() => {
        this.timeCutDown--
        if (this.timeCutDown === 0) {
          clearInterval(timer)
          this.showSend = true
        }
      }, 1000)
    },

    nextToMoreInfo() {
      if (!this.registerForm.verify_code) {
        this.$message.warning('Please input verify code')
        return
      }
      this.registerFirstStep = false
      this.registerSecondStep = true
    },
    intoTermService() {
      this.$router.push('/TermsOfService')
    },
    intoPrivacy() {
      let url = this.roleType === '1' ? '/TalentPrivacyPolicy' : '/ProfessionalsPrivacyPolicy'
      this.$router.push(url)
    },
    routeIntoInfo() {
      // let link = this.type === '1' ? '/CandidateInfo' : '/CoachInfo'
      // this.$router.push(link)
    },
    // 登陆
    handleSubmit() {
      if (!this.privacyChecked) {
        this.showShakeFlag = true
        setTimeout(() => {
          this.showShakeFlag = false
        }, 500)
        this.$message.warning('Please agree to the terms of service and privacy policy')
        return
      }
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          this.signInLoading = true
          let params = {
            role_key: this.roleType === '1' ? 'individual' : 'coach',
            email: this.loginForm.email,
            password: this.loginForm.password
          }
          signIn(params).then((res) => {
            this.signInLoading = false
            if (res.code === 0) {
              //console.log(res.data.token)
                this.$store.dispatch("user:logIn", res.data).then(() => {
                  this.getAdminInfo()
                })
            } else {
              this.signInLoading = false
              this.$message.error(res.message);
            }
          }).catch(() => {
            this.signInLoading = false
          });
        }
      });
    },

    //获取登陆人信息
    getAdminInfo() {
      getUserInfo({}).then((res) => {
        if (res.code === 0) {
          this.$store.dispatch("user:userinfo", res.data);
          if (res.data.roles[0].key == 'coach') {  //表示是教练
            if (res.data.extra_info == null || res.data.extra_info.is_completed == false) {  //表示没有填写过coach信息
              this.$router.push('/CoachInfo')
            } else {
              this.$router.push('/CoachShow')
            }
          } else { // 表示是求职者
            if (res.data.extra_info == null || res.data.extra_info.is_completed == false) {  //表示没有填写过candidate信息
              this.$router.push('/CandidateInfo')
            } else {
              this.$router.push('/CandidateReport')
            }
          }
          
        } else {
          this.$message.error(res.message);
        }
      })
    },

    // 注册
    handleRegister() {
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.registerForm))
          params.role_key = this.roleType === '1' ? 'individual' : 'coach'
          userRegister(params).then((res) => {
            if (res.code === 0) {
              this.$message.success('Register success');
              // this.registerFlag = false
              // this.loginFalg = true
              // this.loginForm.email = params.email

              // 成功后直接登陆
              let loginParams = {
                role_key: this.roleType === '1' ? 'individual' : 'coach',
                email: params.email,
                password: params.password
              }
              signIn(loginParams).then((res) => {
                if (res.code === 0) {
                    this.$store.dispatch("user:logIn", res.data).then(() => {
                      this.getAdminInfo()
                    })
                } else {
                  this.$message.error(res.message);
                }
              })
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    // 忘记密码
    handleForgetPassword() {
      this.$refs['forgotPwsForm'].validate((valid) => {
        if (valid) {
          this.forgotLoading = true
          let params = JSON.parse(JSON.stringify(this.forgotPwsForm))
          userForgetPassword(params).then((res) => {
            this.forgotLoading = false
            if (res.code === 0) {
              this.$message.success('Reset password success');
              this.forgotPwsFlag = false
              this.loginFalg = true
              this.loginForm.email = params.email
              this.forgotPwsForm = {
                email: '',
                verify_code: '',
                password: '',
                confirm_password: ''
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    }


  }
}
</script>
<style lang="scss" scoped>
.lepain-login-page {
  padding: 32px 42px 0 42px;
  .login-talent {
    background: #FF8850;
  }
  .login-coach {
    background: #fef8d9;
  }
  .login-back-img {
    border-radius: 24px;
    height: calc(100vh - 65px);
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .back-icon {
    color: #424242;
    text-align: left;
    font-family: "Zen Kaku Gothic Antique";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22.53px; /* 176.016% */
    margin-bottom: 36px;
    cursor: pointer;
  }
  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 30px;
    height: calc(100vh - 200px);
  }
  .title {
    color: #20273E;
    font-family: Poppins;
    font-size: 28px;
    font-weight: 600;
    letter-spacing: 3.36px;
    text-align: center;
    margin-bottom: 32px;
  }
  .form-content {
    width: 55%;
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    //height: calc(100vh - 300px);
  }
  .privacy-policy {
    width: 380px;
    margin: 0 auto;
    color: #313957;
    text-align: center;
    font-family: Roboto;
    line-height: 28px;
    font-size: 16px;
    font-weight: 400;
    //margin-top: 20px;
    span {
      color: #1E4AE9;
      cursor: pointer;
    }
  }
  .regiter-tips {
    color: #313957;
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 400;
    //margin-top: 32px;
    span {
      color: #1E4AE9;
      cursor: pointer;
    }
  }
  .shake {
    animation: shake-move 0.5s; /* 持续时间0.5秒，无限次循环 */
  }
  /* 定义动画 */
  @keyframes shake-move {
    0%, 100% {
      transform: translateX(0);
    }
    10%, 30%, 50%, 70%, 90% {
      transform: translateX(-10px);
    }
    20%, 40%, 60%, 80% {
      transform: translateX(10px);
    }
  }
  /* 打字机效果的关键帧动画 */
  @keyframes typewriter {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }

  /* 应用动画到 .typewriter 类 */
  .typewriter {
    overflow: hidden; /* 隐藏溢出的内容 */
    //border-right: 0.1em solid; /* 模拟打字机光标 */
    white-space: nowrap; /* 保持内容在一行内 */
    margin: 0 auto; /* 居中显示 */
    letter-spacing: 0.1em; /* 字符间距 */
    animation: 
      typing 3s steps(40, end), /* 打字效果 */
      //blink-caret 1s step-end infinite; /* 光标闪烁效果 */
  }

  /* 打字效果的关键帧动画 */
  @keyframes typing {
    from { width: 0 }
    to { width: 100% }
  }

  /* 光标闪烁效果的关键帧动画 */
  @keyframes blink-caret {
    from, to { border-color: transparent }
    50% { border-color: black }
  }
}
</style>
<style lang="scss">
.lepain-login-page{
  .el-form-item__label {
    color: #0C1421;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
    letter-spacing: 0.16px;
    margin-top: 10px;
  }
}
</style>
